import { Box, Link, Image } from '@chakra-ui/react'
import type { ReactElement } from 'react'
import { useContext } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { UserContext } from '../../../providers'
import { PublicLinksInfoContext } from '../../../providers/PublicLinksInfoProvider'
import { ThreadAvatarOverlay } from '../Details/Threads'
import { PermissionsEnum, checkOperationPermission } from '../../../../utils'
import { ACLPermissionEnum } from '../../../constants'
import type { FileDetailsResponse, MediaLibrarySearchFileResponse } from '../../../interfaces'
import PermissionGuard from '../../PermissionGuard'
import LazyNewThreadPanel from '../Details/Threads/LazyNewThreadPanel'
import type { FilePreviewProps } from '.'

const PDFPreview = ({
  file,
  showThreads = false,
  showPreview = false,
}: FilePreviewProps): ReactElement => {
  const { isPublicLink } = useContext(PublicLinksInfoContext)
  const { thumbnail, url } = file
  const previewUrl = (file as FileDetailsResponse).previewUrl
  const { t } = useTranslation()
  const { user } = useContext(UserContext)

  return (
    <Box position="relative" height="100%" width="100%">
      {showPreview ? (
        <object
          title="PDF File Preview"
          height="100%"
          width="100%"
          data={previewUrl ?? url}
        >
          <Trans t={t} i18nKey="unsupported_browser_pdf">
            Your browser does not support viewing PDF files. You can view the
            file by
            <Link href={previewUrl ?? url} target="_blank">
              clicking here
            </Link>
          </Trans>
        </object>
      ) : (
        <Image src={thumbnail} boxSize="100%" padding="0" />
      )}
      {showThreads && !isPublicLink ? (
        <>
          <PermissionGuard
            permission={PermissionsEnum.RESTRICTED_SELF_MEDIA_LIBRARY_MANAGE}
          >
            {(hasPermission: boolean) =>
              hasPermission &&
              checkOperationPermission({
                user,
                aclPermission: [
                  ACLPermissionEnum.CONTRIBUTE,
                  ACLPermissionEnum.MANAGE,
                ],
                selectedFiles: [file] as MediaLibrarySearchFileResponse[],
                selectedFolders: [],
                selectedMediaCollections: [],
              }) ? (
                <LazyNewThreadPanel
                  fileDetails={file}
                  position={null}
                  setThreadPanelPosition={() => {}}
                />
              ) : (
                <></>
              )
            }
          </PermissionGuard>
          <ThreadAvatarOverlay fileDetails={file} />
        </>
      ) : null}
    </Box>
  )
}

export default PDFPreview
